import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { LOGO_URL } from "../../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const u = await login(form.email, form.password);
      if (u.role !== "admin") { toast.error("Accès admin uniquement"); setLoading(false); return; }
      navigate("/admin");
    } catch { toast.error("Identifiants invalides"); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center bg-berulia-beige px-6">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-berulia-border p-8">
        <div className="text-center"><img src={LOGO_URL} className="h-14 mx-auto" alt=""/><p className="overline text-berulia-rosedeep mt-3">Back-office</p></div>
        <label className="block mt-8"><span className="overline">Email</span><input data-testid="admin-email" required type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} className="mt-1 w-full border border-berulia-border px-3 py-2"/></label>
        <label className="block mt-4"><span className="overline">Mot de passe</span><input data-testid="admin-password" required type="password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} className="mt-1 w-full border border-berulia-border px-3 py-2"/></label>
        <div className="mt-2 text-right">
          <Link to="/mot-de-passe-oublie" data-testid="admin-forgot-link" className="text-xs text-berulia-inkmuted hover:text-berulia-rosedeep link-underline">
            Mot de passe oublié ?
          </Link>
        </div>
        <button disabled={loading} data-testid="admin-login-submit" className="mt-6 w-full bg-berulia-ink text-berulia-beige overline py-3">{loading?"…":"Connexion →"}</button>
      </form>
    </div>
  );
}
